import common from 'components/Collectible/assets/images/common.jpg';
import epic from 'components/Collectible/assets/images/epic.jpg';
import legendary from 'components/Collectible/assets/images/legendary.jpg';
import special from 'components/Collectible/assets/images/special.jpg';
import unique from 'components/Collectible/assets/images/unique.jpg';

export default {
  common, epic, legendary, special, unique,
};
